<template>
  <div class="mb-6">
    <vx-card>
      <vs-row>
        <vs-col vs-w="3">
          <span>Liste des clients</span>
          <v-select
            v-model="form.client"
            class="w-full"
            label="social_reason"
            placeholder="Sélectionner un client"
            :reduce="(user) => user.id"
            :options="customers"
          ></v-select>
        </vs-col>
        <vs-col vs-w="3">
          <span>Liste des priorités</span>
          <v-select
            v-model="form.priority"
            class="w-full"
            label="name"
            placeholder="Sélectionner une priorité"
            :reduce="(priority) => priority.id"
            :options="priorities"
          ></v-select>
        </vs-col>
        <vs-col vs-w="3">
          <span class="vs-select--label text-black">Période</span>
          <date-range-picker
            ref="picker"
            :opens="opens"
            :locale-data="locale"
            :singleDatePicker="false"
            :timePicker="false"
            :showWeekNumbers="showWeekNumbers"
            :showDropdowns="showDropdowns"
            :autoApply="autoApply"
            v-model="dateRange"
            :ranges="false"
            @update="updateValues"
            :linkedCalendars="linkedCalendars"
            :dateFormat="dateFormat"
            :always-show-calendars="false"
            :alwaysShowCalendars="alwaysShowCalendars"
            class="vs-inputx vs-input--input"
          >
            <div slot="input" slot-scope="picker" style="min-width: 350px">
              {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </div>
          </date-range-picker>
        </vs-col>
        <vs-col vs-w="1">
          <vs-button
            class="mt-6"
            @click="searchMethod"
            color="primary"
            type="border"
            size="medium"
            >Filtrer
          </vs-button>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";

export default {
  name: "FilterList",
  components: { DateRangePicker },
  props: {
    customers: {
      type: Array,
      required: true,
      default: () => [],
    },
    priorities: {
      type: Array,
      required: true,
      default: () => [],
    },
    callBackFilter: {
      type: Function,
    },
  },
  data: () => ({
    form: {
      page: 1,
      client: "",
      priority: "",
      dateDebut: "",
      dateFin: "",
    },
    locale: {
      direction: "ltr",
      format: "dd/mm/yyyy",
      separator: " - ",
      applyLabel: "Appliquer",
      cancelLabel: "Annuler",
      weekLabel: "W",
      customRangeLabel: "Custom Range",
      daysOfWeek: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      monthNames: [
        "Jan",
        "Fev",
        "Mar",
        "Avr",
        "Mai",
        "Jui",
        "Juil",
        "Aou",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      firstDay: 0,
    },
    opens: "center",
    showWeekNumbers: true,
    linkedCalendars: true,
    alwaysShowCalendars: true,
    showDropdowns: true,
    autoApply: false,
    dateRange: {
      startDate: "",
      endDate: "",
    },
  }),
  watch: {},
  computed: {},
  methods: {
    searchMethod() {
      this.form.dateDebut = this.dateRange.startDate ? this.dateRange.startDate : "";
      this.form.dateFin = this.dateRange.endDate ? this.dateRange.endDate : "";
      for (let key in this.form){
        if(this.form[key] == null){
            this.form[key] = "";
        }
      }
      this.callBackFilter(this.form);
    },
    updateValues(values) {
      this.dateRange.startDate = moment(values.startDate).format("YYYY-MM-DD");
      this.dateRange.endDate = moment(values.endDate).format("YYYY-MM-DD");
    },
    dateFormat(classes, date) {
      // let yesterday = moment().subtract(1, "day");
      // if (!classes.disabled) {
      //   classes.disabled = moment(date).isSame(yesterday, 'day')
      // }
      return classes;
    },
  },
  mounted() {
    //this.dateRange.startDate = moment(new Date()).format("YYYY-MM-DD");
    //this.dateRange.endDate = moment(new Date()).format("YYYY-MM-DD");
  },
};
</script>

<style scoped>
</style>
